module.exports = __webpack_public_path__ + "img/c06_unitstartechcultivation_Normal_ua.18382ba0.webp";